import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import BackButton from "../../components/BackButton/BackButton";
import "../../components/LoadingSpinner/spinner.css";
import { getChargeName } from "../../redux/actions/getChargeNameAction";
import { addMerchantCharge } from "../../redux/actions/addMerchantChargeAction";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import Input from "@mui/material/Input";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import {
    getKycApproveRejects,
    resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import authTokenReducer from "../../redux/reducers/authTokenReducer";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
import Autocomplete from "@mui/lab/Autocomplete";

// const useStyles = makeStyles({
//     table: {
//         minWidth: 650
//     }
// });

const useStyles = makeStyles((theme) => ({
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    chips: {
        display: "flex",
        flexWrap: "wrap"
    },
    chip: {
        margin: 2
    },
    noLabel: {
        // marginTop: theme.spacing(3)
    },
    table: {
        minWidth: 650
    }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};

function AddMerchantCharges() {
    const navigate = useHistory();
    const [addNotification, setAddNotification] = useState(false);

    const [getChargeNameStatus, setGetChargeNameStatus] = useState(false);
    const [getChargeNameArray, setGetChargeNameArray] = useState("");

    const [addMerchantChargeStatus, setAddMerchantChargeStatus] = useState(false);
    const [addMerchantChargeArray, setAddMerchantChargeArray] = useState("");

    // const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();

    const [merchantId, setMerchantId] = useState("")
    const [chargeName, setChargeName] = useState([])
    const [currency, setCurrency] = useState("")

    const [reqArr, setReqArr] = useState([])
    const [modal, setmodal] = useState(false);

    const handlechnage = () => {
        setmodal(!modal);
    }

    const onInputChange = ({ target: { name, value } }) => {
        // if (name === "merchantId") {
        //     setMerchantId(value);
        // }
        if (name === "chargeName") {
            setChargeName(value);
        }
        if (name === "currency") {
            setCurrency(value);
        }
    };
    const handleChange = ({ target: { name, value } }) => {
        if (name === "merchantId") {
            setMerchantId(value);
        }
        if (name === "chargeName") {
            setChargeName(value);
        }
        if (name === "currency") {
            setCurrency(value);
        }
    };

    const getChargeNameRes = useSelector(({ getChargeName }) => getChargeName);
	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
    const addMerchantChargeRes = useSelector(
        ({ addMerchantCharge }) => addMerchantCharge
    );

    const adminCurrencyList = useSelector(
        ({ adminCurrencyList }) => adminCurrencyList
    );

    const getChargeNameReq = () => {
        setGetChargeNameStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId
            }
        };
        dispatch(getChargeName(req, authToken));
    };

    const getChargeNameFunc = () => {
        if (getChargeNameStatus) {
            if (getChargeNameRes.data.status == "success") {
                setGetChargeNameArray(getChargeNameRes.data.chargeList);
            }
            if (getChargeNameRes.data.status == "failed") {
                setGetChargeNameArray(getChargeNameRes.data);
                if (
                    getChargeNameRes.data.description == "session out" ||
                    getChargeNameRes.data.description == "Authorization failed"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getChargeNameFunc();
    }, [getChargeNameRes.data.status]);

    const mapFunc = () => {
        setReqArr(chargeName.map((x) => (
            {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                memberCharge: "0.00",
                agentCharge: "0.00",
                partnerCharge: "0.00",
                fdtstamp: "",
                tdtstamp: "",
                isDynamicInput: "",
                mappindId: "",
                memberId: merchantId.split("-")[0] || "",
                currency: currency,
                chargeId: x,
                sequenceNumber: ""
            }
        )))
    }

    const addMerchantChargeReq = () => {
        setAddMerchantChargeStatus(true)
        let AddChargeMaster = reqArr.map((p) => ({ ...p, chargeId: p.chargeId.split("-")[0] }))
        let req = {
            actionCustomerMasterRequestVOList: AddChargeMaster
        }
        dispatch(addMerchantCharge(req, authToken))
    }

    const addMerchantChargeFunc = () => {
        if (addMerchantChargeStatus) {
            if (addMerchantChargeRes.data.status == "success") {
                setAddMerchantChargeArray(addMerchantChargeRes.data);
                setAddNotification(true);
                setReqArr([])
                setChargeName([])
            }
            if (addMerchantChargeRes.data.status == "failed") {
                setAddMerchantChargeArray(addMerchantChargeRes.data);
                setAddNotification(true);
                setReqArr([])
                setChargeName([])
                if (
                    addMerchantChargeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addMerchantChargeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        addMerchantChargeFunc();
    }, [addMerchantChargeRes.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getChargeNameReq();
        }
    }, [regenerateTokenRes.data.status]);

    const handleNoticationClose = () => {
        setAddNotification(false);
    };

    let a = []

    for (let i = 1; i < 51; i++) {
        a.push(i)
    }

    var obj = reqArr

    const dynamicInputFunc = (value, index) => {
        obj[index].isDynamicInput = value
        setReqArr([])
        setReqArr([].concat(obj))
    };

    const sequenceNumFunc = (value, index) => {
        obj[index].sequenceNumber = value
        setReqArr([])
        setReqArr([].concat(obj))
    };

    const handlefeeChargesFn = (idx, valueScore, nameScore) => {
        if (nameScore == "memberCharge") {
            obj[idx].memberCharge = valueScore;
            setReqArr([])
            setReqArr([].concat(obj))
        }
        if (nameScore == "agentCharge") {
            obj[idx].agentCharge = valueScore;
            setReqArr([])
            setReqArr([].concat(obj))
        }
        if (nameScore == "partnerCharge") {
            obj[idx].partnerCharge = valueScore;
            setReqArr([])
            setReqArr([].concat(obj))
        }
    };

    const dateChange = (index, value, type) => {
        if (type == "start") {
            obj[index].fdtstamp = value;
            if (new Date(value) > new Date(obj[index].tdtstamp)) {
                obj[index].tdtstamp = value;
            }
            // setReqArr([])
            setReqArr([].concat(obj))
        }
        if (type == "end") {
            if (new Date(value) < new Date(obj[index].fdtstamp)) {
                obj[index].tdtstamp = obj[index].fdtstamp;
            } else {
                obj[index].tdtstamp = value;
            }
            setReqArr([])
            setReqArr([].concat(obj))
        }
    }

    useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])
    useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

    const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}


    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={8} sm={3} lg={8}></Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        {/* <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Merchant Id*"
                                variant="standard"
                                fullWidth={true}
                                name="merchantId"
                                value={merchantId || ""}
                                onChange={onInputChange}
                            >
                            </TextField>
                        </Grid> */}
                        <Grid item xs={12} sm={6} md={4} lg={4}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={merchantId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setMerchantId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Merchant ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}
									
											name="merchantId"
											
											variant="standard"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                  borderBottomColor: "gray", // White color for the underline before focus
                                                },
                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                  borderBottomColor: "gray", // White color on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                  borderBottomColor: "gray", // White color after focus
                                                },
                                              }}
										/>
									)}
								/>
							</Grid>

                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            {getChargeNameRes.data.chargeList && (
                                <FormControl
                                    style={{
                                        width: "100%",
                                        margin: "-3px 0px 0px",
                                        maxWidth: "unset",
                                        minWidth: "unset",
                                    }}
                                    className={classes.formControl}
                                >
                                    <InputLabel style={{ color: "#092058" }}>
                                        Charge Name*
                                    </InputLabel>
                                    <Select
                                        multiple
                                        color="primary"
                                        value={chargeName}
                                        onChange={onInputChange}
                                        name="chargeName"
                                        input={<Input />}
                                        renderValue={(selected) => selected.join(",")}
                                        MenuProps={MenuProps}
                                        sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
                                    >
                                        {getChargeNameRes.data.chargeList &&
                                            getChargeNameRes.data.chargeList.map((x) => (
                                                <MenuItem value={x.chargeid + "-" + x.chargename}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={chargeName.indexOf(x.chargeid + "-" + x.chargename) > -1}
                                                    />
                                                    <ListItemText primary={x.chargename} />
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Currency*"
                                fullWidth={true}
                                variant="standard"
                                name="currency"
                                defaultValue={currency || "Select Currency"}
                                onChange={onInputChange}
                                sx={{
                                    "& .MuiInput-underline:before": {
                                      borderBottomColor: "gray", // White color for the underline before focus
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                      borderBottomColor: "gray", // White color on hover
                                    },
                                    "& .MuiInput-underline:after": {
                                      borderBottomColor: "gray", // White color after focus
                                    },
                                  }}
                            >
                                <MenuItem
                                    value="Select Currency"
                                    selected="Select Currency"
                                >
                                    Select Currency
                                </MenuItem>
                                {adminCurrencyList.success &&
                                    []
                                        .concat(adminCurrencyList.data.currencyList)
                                        .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <CustomButton
                            style={{
                                padding: "10px 20px",
                                margin: "61px auto 11px"
                            }}
                            //disabled={(merchantId == "" && currency == "Select Currency" && chargeName == []) ? false : true}
                            onClick={mapFunc}
                        >
                            Add
                        </CustomButton>
                    </Grid>
                </Card>

                {
                    // isLoading ? (
                    //     <LoadingSpinner />
                    // ) : 
                    reqArr.length == 0 ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >

                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"
                                        style={{ color: "white" }}
                                    >
                                        Add Charge Name
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <div>
                            <Card>
                                <Grid
                                    container
                                    style={{
                                        padding: "10px"
                                    }}
                                >
                                    <Grid xs={12} sm={12} md={12} lg={12}>
                                        <Typography variant="body1" style={{ fontWeight: "700" }}>
                                            Report Table
                                        </Typography>
                                    </Grid>
                                    <TableContainer component={Paper} className="text-nowrap my-3">
                                        <Table className={classes.table}>
                                            <TableHead>
                                                <TableRow className="tableHeaderColor">
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Charge Name{" "}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Dynamic Input
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Start Date
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        End Date
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Merchant Rate
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Agent Commission
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Partner Commission
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Sequence Number
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {reqArr &&
                                                    []
                                                        .concat(reqArr)
                                                        .map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell align="center">
                                                                    {row.chargeId.split("-")[1]}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        select
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        name="ruleeStatus"
                                                                        value={row.isDynamicInput}
                                                                    >
                                                                        <MenuItem
                                                                            onClick={() => dynamicInputFunc("Y", index)}
                                                                            value={"Y"}
                                                                        >
                                                                            Y
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            onClick={() => dynamicInputFunc("N", index)}
                                                                            value={"N"}
                                                                        >
                                                                            N
                                                                        </MenuItem>
                                                                    </TextField>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        type="date"
                                                                        value={row.fdtstamp}
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        onChange={({ target: { value } }) =>
                                                                            dateChange(index, value, "start")
                                                                        }
                                                                    >
                                                                    </TextField>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        type="date"
                                                                        value={row.tdtstamp}
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        onChange={({ target: { value } }) =>
                                                                            dateChange(index, value, "end")
                                                                        }
                                                                        InputProps={{
                                                                            inputProps: {
                                                                                min: row.fdtstamp,
                                                                            },
                                                                        }}
                                                                    >
                                                                    </TextField>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        className="removeArrows"

                                                                        type="number"
                                                                        value={row.memberCharge}
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        onChange={({ target: { value } }) =>{
                                                                            const memberCharge = parseFloat(value);
                                                                            if(memberCharge >=0 || value === ''){
                                                                            handlefeeChargesFn(index, value, "memberCharge")
                                                                            }
                                                                        }}
                                                                    >
                                                                    </TextField>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        className="removeArrows"

                                                                        type="number"
                                                                        value={row.agentCharge}
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        onChange={({ target: { value } }) =>{
                                                                            const agentCharge = parseFloat(value);
                                                                            if(agentCharge >=0 || value === ''){
                                                                            handlefeeChargesFn(index, value, "agentCharge")
                                                                            }
                                                                        }}
                                                                    >
                                                                    </TextField>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        className="removeArrows"

                                                                        type="number"
                                                                        value={row.partnerCharge}
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        onChange={({ target: { value } }) =>{
                                                                            const partnerCharge = parseFloat(value);
                                                                            if(partnerCharge >=0 || value===''){
                                                                            handlefeeChargesFn(index, value, "partnerCharge")
                                                                            }
                                                                        }}
                                                                    >
                                                                    </TextField>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <TextField
                                                                        select
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        name="ruleeStatus"
                                                                        value={row.sequenceNumber}
                                                                    >
                                                                        {
                                                                            a.map((x) => (
                                                                                <MenuItem
                                                                                    onClick={() => sequenceNumFunc(x, index)}
                                                                                    value={x}>
                                                                                    {x}
                                                                                </MenuItem>
                                                                            ))}
                                                                    </TextField>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <CustomButton
                                    style={{
                                        padding: "10px 20px",
                                        margin: "61px auto 11px"
                                    }}
                                    // disabled={(merchantId == "" && currency == "Select Currency" && chargeName == []) ? false : true}
                                    onClick={addMerchantChargeReq}
                                >
                                    Save
                                </CustomButton>
                            </Card>
                        </div>
                    )}
            </Layout>

            {addMerchantChargeArray.status == "success" && (
                <div>
                    <Dialog open={addNotification} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addMerchantChargeArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addMerchantChargeArray.status == "failed" && (
                <div>
                    <Dialog open={addNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addMerchantChargeArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    );
}

export default AddMerchantCharges;

